import Input from 'components/form/input';
import Popup from 'components/popup/Popup';
import { t } from 'i18next';
import React, { useState } from 'react';
import validator from 'validator';


interface IReportEmailModalProps {
  open: boolean;
  onEmailSelected: (email: string) => void;
  onClose: () => void;
}

export default function ReportEmailModal({ open, onEmailSelected, onClose }: IReportEmailModalProps) {

  const email = localStorage.getItem('report-export-email') ?? '';
  const [exportEmail, setExportEmail] = useState({
    isDirty: email.length > 0,
    isValid: validator.isEmail(email),
    value: email,
  });

  return <Popup
    open={open}
    type={'info'}
    title={t('Email Required for Export')}
    description={t('An email is required to send the report to upon completion. Please provide a desination email.')}
    okText={t("Export")}
    onOk={() => {
      localStorage.setItem('report-export-email', exportEmail.value);
      onEmailSelected(exportEmail.value);
    }}
    onCancel={onClose}
    okDisabled={!exportEmail.isValid || !exportEmail.isDirty || (exportEmail.isDirty && !exportEmail.isValid)}
  >
    <br />
    <Input
      type={"email"}
      label={t("Email")}
      value={exportEmail.value}
      onChange={e =>
        setExportEmail({ isDirty: true, isValid: validator.isEmail(e.target.value), value: e.target.value })
      }
      error={exportEmail.isDirty && !exportEmail.isValid}
    ></Input>
  </Popup>;
}
